function Mail({ style }) {
  const { fill = '#63637B', width = 32, height = 32 } = style || {};
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 32 32"
    >
      <path
        stroke={fill}
        strokeLinecap="square"
        strokeWidth="2"
        d="M27.999 10v15h-24V10"
      />
      <path
        stroke={fill}
        strokeLinecap="square"
        strokeWidth="2"
        d="M27.999 10V7h-24v3l12 6.956 12-6.956Z"
      />
    </svg>
  );
}

export default Mail;
